module.exports = __webpack_public_path__ + "img/tab-background-right-v2.6cf385fd.svg";